import bag from "~/assets/icons/bag.svg";
import clock from "~/assets/icons/clock.svg";
import gtick from "~/assets/icons/gtick.svg";
import keypad from "~/assets/icons/keypad.svg";
import net from "~/assets/icons/net.svg";
import prompt from "~/assets/icons/prompt.svg";
import social from "~/assets/icons/social.svg";
import guard from "~/assets/icons/guard.svg";
import thunder from "~/assets/icons/thunder.svg";
import analysis from "~/assets/icons/analysis.svg";
import tick from "~/assets/icons/tick.svg";
import chart from "~/assets/icons/chart.svg";
import headphones from "~/assets/icons/headphones.svg";
import star from "~/assets/icons/star.svg";
import lock from "~/assets/icons/lock.svg";
import aparat from "~/assets/icons/aparat.svg";
import linkedin from "~/assets/icons/linkedin.svg";
import cross from "~/assets/icons/cross.svg";
import check from "~/assets/icons/check.svg";

import type { BucketIcon } from "~/types/icon";

const bucket: Record<BucketIcon, string> = {
  bag: bag.src,
  clock: clock.src,
  gtick: gtick.src,
  keypad: keypad.src,
  net: net.src,
  prompt: prompt.src,
  social: social.src,
  guard: guard.src,
  analysis: analysis.src,
  thunder: thunder.src,
  tick: tick.src,
  chart: chart.src,
  headphones: headphones.src,
  star: star.src,
  lock: lock.src,
  linkedin: linkedin.src,
  aparat: aparat.src,
  cross: cross.src,
  check: check.src,
}

export default bucket
